import React, { setGlobal, useState } from 'reactn';
import { Form, Input, Button, Layout , Row, Col, message } from 'antd';
import { useAuth } from 'reactfire';
// import Fetcher from '../../Utils/fetcher';
import { Redirect } from 'react-router-dom';
// import API from '../../Utils/api';
import {is_user_loggedin} from '../../Utils/auth';
// import useSWR from 'swr';


const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
};
const tailLayout = {
    wrapperCol: { offset: 0, span: 24 },
};


const { Content } = Layout;

// const { data, error } = useSWR('/api/user/123', Fetcher)
// if (error) return <div>failed to load</div>
// if (!data) return <div>loading...</div>

const Login = () => {
    const [redirect, setRedirect] = useState(false);

    const auth = useAuth();

    const onFinish = values => {
        console.log('Success:', values);

        auth.signInWithEmailAndPassword(values.contactNumber , values.password).then(resp => {
            // console.log(resp);
                        setRedirect(true);
                        is_user_loggedin(resp);
                        setGlobal({is_user_loggedin: true});
        }).catch((error) => {
          message.error(error.message);
          console.log(error);
        })

        // API.post(`user/login`, values).then((response) => {
        //     console.log(response);
        //     setRedirect(true);
        //     setGlobal({user: response.data})
        //     save_user(response.data);
        // })

      };
    
      const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
      };

    return (
        
            <React.Fragment>
              {redirect ? <Redirect to="/patients" /> : ''  }

                <div className='page'>

                    <div className='main_wrapper'>

                <div className="introduction">
                    <h1>ENT Management System</h1>
                </div>
                <div className='Wrapper login_container'>
<Row>
    <Col span={24}>
                <Content className="site-layout" style={{ padding: '0 10px', marginTop: 20 }}>
      <div className="site-layout-background" style={{ padding: '15px 0', minWidth: 350 }}>
  
                <Form
      {...layout}
      layout="vertical"
      name="basic"
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="Email Address"
        name="contactNumber"
        rules={[{ required: true, message: 'Please input your username!' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Password"
        name="password"
        rules={[{ required: true, message: 'Please input your password!' }]}
      >
        <Input.Password />
      </Form.Item>


      <Form.Item {...tailLayout}>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>

    </div>
    </Content>
    </Col>
    </Row>

    </div>
    </div>
    </div>
            </React.Fragment>
    );
}

export default Login;
